export const DEFAULT_HANGING_PROTOCOLS = [
    {
        id: 'proto-canine-chest-3v',
        name: 'Canine Chest 3-View',
        species: ['Canine'],
        modality: ['DX', 'CR'],
        bodyParts: ['Thorax', 'Chest'],
        layout: '2x3',
        includePriors: true,
        viewports: [
            { id: 'vp-cc-1', label: 'R Lat', sublabel: 'Current', role: 'current', wlPreset: 'lung' },
            { id: 'vp-cc-2', label: 'VD', sublabel: 'Current', role: 'current', wlPreset: 'lung' },
            { id: 'vp-cc-3', label: 'L Lat', sublabel: 'Current', role: 'current', wlPreset: 'lung' },
            { id: 'vp-cc-4', label: 'R Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'lung' },
            { id: 'vp-cc-5', label: 'VD', sublabel: 'Prior', role: 'prior', wlPreset: 'lung' },
            { id: 'vp-cc-6', label: 'L Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'lung' },
        ],
        wlPreset: 'lung',
        priorConfig: {
            enabled: true,
            matchViews: true,
            sameBodyPartOnly: true,
            maxPriors: 2,
        },
    },
    {
        id: 'proto-canine-abdomen',
        name: 'Canine Abdomen',
        species: ['Canine'],
        modality: ['DX', 'CR'],
        bodyParts: ['Abdomen'],
        layout: '2x2',
        includePriors: true,
        viewports: [
            { id: 'vp-ca-1', label: 'R Lat', sublabel: 'Current', role: 'current', wlPreset: 'abdomen' },
            { id: 'vp-ca-2', label: 'L Lat', sublabel: 'Current', role: 'current', wlPreset: 'abdomen' },
            { id: 'vp-ca-3', label: 'R Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'abdomen' },
            { id: 'vp-ca-4', label: 'L Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'abdomen' },
        ],
        wlPreset: 'abdomen',
        priorConfig: {
            enabled: true,
            matchViews: true,
            sameBodyPartOnly: true,
            maxPriors: 2,
        },
    },
    {
        id: 'proto-canine-ortho',
        name: 'Canine Orthopedic',
        species: ['Canine'],
        modality: ['DX', 'CR'],
        bodyParts: ['Stifle', 'Elbow', 'Shoulder', 'Hip', 'Carpus'],
        layout: '2x2',
        includePriors: true,
        viewports: [
            { id: 'vp-co-1', label: 'R Lat', sublabel: 'Current', role: 'current', wlPreset: 'bone' },
            { id: 'vp-co-2', label: 'L Lat', sublabel: 'Current', role: 'current', wlPreset: 'bone' },
            { id: 'vp-co-3', label: 'R Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'bone' },
            { id: 'vp-co-4', label: 'L Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'bone' },
        ],
        wlPreset: 'bone',
        priorConfig: {
            enabled: true,
            matchViews: true,
            sameBodyPartOnly: true,
            maxPriors: 2,
        },
    },
    {
        id: 'proto-feline-chest-3v',
        name: 'Feline Chest 3-View',
        species: ['Feline'],
        modality: ['DX', 'CR'],
        bodyParts: ['Thorax', 'Chest'],
        layout: '2x3',
        includePriors: true,
        viewports: [
            { id: 'vp-fc-1', label: 'R Lat', sublabel: 'Current', role: 'current', wlPreset: 'lung-fel' },
            { id: 'vp-fc-2', label: 'VD', sublabel: 'Current', role: 'current', wlPreset: 'lung-fel' },
            { id: 'vp-fc-3', label: 'L Lat', sublabel: 'Current', role: 'current', wlPreset: 'lung-fel' },
            { id: 'vp-fc-4', label: 'R Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'lung-fel' },
            { id: 'vp-fc-5', label: 'VD', sublabel: 'Prior', role: 'prior', wlPreset: 'lung-fel' },
            { id: 'vp-fc-6', label: 'L Lat', sublabel: 'Prior', role: 'prior', wlPreset: 'lung-fel' },
        ],
        wlPreset: 'lung-fel',
        priorConfig: {
            enabled: true,
            matchViews: true,
            sameBodyPartOnly: true,
            maxPriors: 2,
        },
    },
    {
        id: 'proto-feline-thorax-abd',
        name: 'Feline Thorax + Abdomen',
        species: ['Feline'],
        modality: ['DX', 'CR'],
        bodyParts: ['Thorax', 'Chest', 'Abdomen'],
        layout: '3x3',
        includePriors: true,
        viewports: [
            {
                id: 'vp-fta-1',
                label: 'R Lat',
                sublabel: 'Thorax / Current',
                role: 'current',
                wlPreset: 'lung-fel',
            },
            {
                id: 'vp-fta-2',
                label: 'VD',
                sublabel: 'Thorax / Current',
                role: 'current',
                wlPreset: 'lung-fel',
            },
            {
                id: 'vp-fta-3',
                label: 'L Lat',
                sublabel: 'Thorax / Current',
                role: 'current',
                wlPreset: 'lung-fel',
            },
            {
                id: 'vp-fta-4',
                label: 'R Lat',
                sublabel: 'Abdomen / Current',
                role: 'current',
                wlPreset: 'abdomen',
            },
            {
                id: 'vp-fta-5',
                label: 'VD',
                sublabel: 'Abdomen / Current',
                role: 'current',
                wlPreset: 'abdomen',
            },
            {
                id: 'vp-fta-6',
                label: 'L Lat',
                sublabel: 'Abdomen / Current',
                role: 'current',
                wlPreset: 'abdomen',
            },
            {
                id: 'vp-fta-7',
                label: 'R Lat',
                sublabel: 'Thorax / Prior',
                role: 'prior',
                wlPreset: 'lung-fel',
            },
            {
                id: 'vp-fta-8',
                label: 'VD',
                sublabel: 'Abdomen / Prior',
                role: 'prior',
                wlPreset: 'abdomen',
            },
            {
                id: 'vp-fta-9',
                label: 'L Lat',
                sublabel: 'Thorax / Prior',
                role: 'prior',
                wlPreset: 'lung-fel',
            },
        ],
        wlPreset: 'lung-fel',
        priorConfig: {
            enabled: true,
            matchViews: true,
            sameBodyPartOnly: true,
            maxPriors: 3,
        },
    },
    {
        id: 'proto-ct-head',
        name: 'CT Head (Canine/Feline)',
        species: ['Canine', 'Feline'],
        modality: ['CT'],
        bodyParts: ['Head', 'Brain'],
        layout: '2x2',
        // CT is read off the transverse stack, so open MPR axial-dominant: the
        // axial pane spans both rows while sagittal and dorsal sit beside it as
        // reference. Leaving the volume out by default also keeps a large CT off
        // the GPU until someone actually asks for 3D. Switchable in the toolbar.
        mprViewConfig: 'mprOnly',
        includePriors: false,
        viewports: [
            {
                id: 'vp-ch-1',
                label: 'Axial',
                sublabel: 'Soft Tissue',
                role: 'current',
                wlPreset: 'ct-brain',
            },
            {
                id: 'vp-ch-2',
                label: 'Sagittal',
                sublabel: 'Soft Tissue',
                role: 'current',
                wlPreset: 'ct-brain',
            },
            {
                id: 'vp-ch-3',
                label: 'Coronal',
                sublabel: 'Soft Tissue',
                role: 'current',
                wlPreset: 'ct-brain',
            },
            {
                id: 'vp-ch-4',
                label: 'Axial',
                sublabel: 'Bone Window',
                role: 'current',
                wlPreset: 'ct-bone',
            },
        ],
        wlPreset: 'ct-brain',
        priorConfig: {
            enabled: false,
            matchViews: false,
            sameBodyPartOnly: true,
            maxPriors: 1,
        },
        syncGroups: [
            {
                id: 'sg-ch-1',
                name: 'Axial / Sag / Cor',
                viewportIds: ['vp-ch-1', 'vp-ch-2', 'vp-ch-3'],
                syncType: 'scroll',
            },
        ],
    },
    {
        id: 'proto-ct-thorax',
        name: 'CT Thorax (Canine)',
        species: ['Canine'],
        modality: ['CT'],
        bodyParts: ['Thorax', 'Chest', 'Lung'],
        layout: '4x2',
        // CT is read off the transverse stack, so open MPR axial-dominant: the
        // axial pane spans both rows while sagittal and dorsal sit beside it as
        // reference. Leaving the volume out by default also keeps a large CT off
        // the GPU until someone actually asks for 3D. Switchable in the toolbar.
        mprViewConfig: 'mprOnly',
        includePriors: false,
        viewports: [
            { id: 'vp-ct-1', label: 'Axial', sublabel: 'Lung', role: 'current', wlPreset: 'lung' },
            {
                id: 'vp-ct-2',
                label: 'Axial',
                sublabel: 'Soft Tissue',
                role: 'current',
                wlPreset: 'soft-tissue',
            },
            { id: 'vp-ct-3', label: 'Axial', sublabel: 'Bone', role: 'current', wlPreset: 'ct-bone' },
            { id: 'vp-ct-4', label: 'Sagittal', sublabel: 'Lung', role: 'current', wlPreset: 'lung' },
            { id: 'vp-ct-5', label: 'Coronal', sublabel: 'Lung', role: 'current', wlPreset: 'lung' },
            {
                id: 'vp-ct-6',
                label: 'Coronal',
                sublabel: 'Soft Tissue',
                role: 'current',
                wlPreset: 'soft-tissue',
            },
            { id: 'vp-ct-7', label: 'MIP', sublabel: 'Lung', role: 'current', wlPreset: 'lung' },
            { id: 'vp-ct-8', label: 'MinIP', sublabel: 'Lung', role: 'current', wlPreset: 'lung' },
        ],
        wlPreset: 'lung',
        priorConfig: {
            enabled: false,
            matchViews: false,
            sameBodyPartOnly: true,
            maxPriors: 1,
        },
        syncGroups: [
            {
                id: 'sg-ct-ax',
                name: 'Axial group',
                viewportIds: ['vp-ct-1', 'vp-ct-2', 'vp-ct-3'],
                syncType: 'scroll',
            },
            {
                id: 'sg-ct-sc',
                name: 'Sagittal + Coronal',
                viewportIds: ['vp-ct-4', 'vp-ct-5', 'vp-ct-6'],
                syncType: 'scroll',
            },
        ],
    },
    {
        id: 'proto-mri-brain',
        name: 'MRI Brain (Canine/Feline)',
        species: ['Canine', 'Feline'],
        modality: ['MR'],
        bodyParts: ['Brain', 'Head'],
        layout: '4x2',
        includePriors: false,
        viewports: [
            { id: 'vp-mb-1', label: 'T2', sublabel: 'Axial', role: 'current', wlPreset: 'mri-t2' },
            { id: 'vp-mb-2', label: 'T1', sublabel: 'Axial', role: 'current', wlPreset: 'mri-t1' },
            { id: 'vp-mb-3', label: 'T1+C', sublabel: 'Axial', role: 'current', wlPreset: 'mri-t1' },
            { id: 'vp-mb-4', label: 'FLAIR', sublabel: 'Axial', role: 'current', wlPreset: 'mri-flair' },
            { id: 'vp-mb-5', label: 'T2', sublabel: 'Sagittal', role: 'current', wlPreset: 'mri-t2' },
            { id: 'vp-mb-6', label: 'T1', sublabel: 'Sagittal', role: 'current', wlPreset: 'mri-t1' },
            { id: 'vp-mb-7', label: 'T1+C', sublabel: 'Sagittal', role: 'current', wlPreset: 'mri-t1' },
            { id: 'vp-mb-8', label: 'DWI', sublabel: 'Axial', role: 'current', wlPreset: 'mri-t2' },
        ],
        wlPreset: 'mri-t2',
        priorConfig: {
            enabled: false,
            matchViews: false,
            sameBodyPartOnly: true,
            maxPriors: 1,
        },
        syncGroups: [
            {
                id: 'sg-mb-r1',
                name: 'Axial row',
                viewportIds: ['vp-mb-1', 'vp-mb-2', 'vp-mb-3', 'vp-mb-4'],
                syncType: 'scroll',
            },
            {
                id: 'sg-mb-r2',
                name: 'Sagittal group',
                viewportIds: ['vp-mb-5', 'vp-mb-6', 'vp-mb-7'],
                syncType: 'scroll',
            },
        ],
    },
    {
        id: 'proto-mri-spine',
        name: 'MRI Spine (Canine/Feline)',
        species: ['Canine', 'Feline'],
        modality: ['MR'],
        bodyParts: ['Spine', 'Lumbar', 'L3', 'L4', 'L5'],
        layout: '2x3',
        // Spine reads off the sagittal, and a spine sagittal is a wide, short
        // image: an even quad spends most of its box on empty space while the
        // plane that matters stays small. Requested by a neurologist reading
        // spine MR. The reader can still switch in the MPR toolbar.
        mprViewConfig: 'sagittalTop',
        includePriors: false,
        viewports: [
            { id: 'vp-ms-1', label: 'T2', sublabel: 'Sagittal', role: 'current', wlPreset: 'mri-t2' },
            { id: 'vp-ms-2', label: 'T1', sublabel: 'Sagittal', role: 'current', wlPreset: 'mri-t1' },
            {
                id: 'vp-ms-3',
                label: 'T2 STIR',
                sublabel: 'Sagittal',
                role: 'current',
                wlPreset: 'mri-t2',
            },
            { id: 'vp-ms-4', label: 'T2', sublabel: 'Axial L3', role: 'current', wlPreset: 'mri-t2' },
            { id: 'vp-ms-5', label: 'T2', sublabel: 'Axial L4', role: 'current', wlPreset: 'mri-t2' },
            { id: 'vp-ms-6', label: 'T2', sublabel: 'Axial L5', role: 'current', wlPreset: 'mri-t2' },
        ],
        wlPreset: 'mri-t2',
        priorConfig: {
            enabled: false,
            matchViews: false,
            sameBodyPartOnly: true,
            maxPriors: 1,
        },
        syncGroups: [
            {
                id: 'sg-ms-sag',
                name: 'Sagittal row',
                viewportIds: ['vp-ms-1', 'vp-ms-2', 'vp-ms-3'],
                syncType: 'scroll',
            },
        ],
    },
];
